import { render, staticRenderFns } from "./ProjectModule.vue?vue&type=template&id=66d40d23&scoped=true"
import script from "./ProjectModule.vue?vue&type=script&lang=js"
export * from "./ProjectModule.vue?vue&type=script&lang=js"
import style0 from "./ProjectModule.vue?vue&type=style&index=0&id=66d40d23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d40d23",
  null
  
)

export default component.exports